import { render, staticRenderFns } from "./CAddressSelect.vue?vue&type=template&id=a5dae498&scoped=true"
import script from "./CAddressSelect.vue?vue&type=script&lang=js"
export * from "./CAddressSelect.vue?vue&type=script&lang=js"
import style0 from "./CAddressSelect.vue?vue&type=style&index=0&id=a5dae498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dae498",
  null
  
)

export default component.exports